import { CheckoutState } from '../../state';
import { getEmailToPrefillFirstAttendeeInfo } from './getEmailToPrefillFirstAttendeeInfo';
import { getFirstNameToPrefillFirstAttendeeInfo } from './getFirstNameToPrefillFirstAttendeeInfo';
import { getLastNameToPrefillFirstAttendeeInfo } from './getLastNameToPrefillFirstAttendeeInfo';
import { getFirstAttendeeWithSurvey } from './pureSelectors';

export const getPrefillFirstAttendeeInfo = (state: CheckoutState) => ({
    emailToPrefill: getEmailToPrefillFirstAttendeeInfo(state),
    firstNameToPrefill: getFirstNameToPrefillFirstAttendeeInfo(state),
    lastNameToPrefill: getLastNameToPrefillFirstAttendeeInfo(state),
    attendeeWithSurvey: getFirstAttendeeWithSurvey(state),
});
